import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProfileFilledreact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "UserAdded",
		children: /* @__PURE__ */ _jsx("path", {
			id: "icon",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.68754 9.23611C12.0079 9.23611 13.8889 7.35508 13.8889 5.03472C13.8889 2.71435 12.0079 0.833328 9.68754 0.833328C7.36717 0.833328 5.48615 2.71435 5.48615 5.03472C5.48615 7.35508 7.36717 9.23611 9.68754 9.23611ZM8.5306 10.8333H10.6326C14.8846 10.8333 18.3333 13.7051 18.3333 17.2493V19.1667H0.833336V17.2493C0.833336 13.7051 4.27865 10.8333 8.5306 10.8333Z",
			fill: "#3E4088"
		})
	})
});
export default SvgProfileFilledreact;
